<template>
  <module-box
    type="zs-tab-info"
    :mode="mode"
    :moduleData="moduleData"
    showSetup
    customClass="tab-box"
    @onSetup="handleOpenModuleSetupPanel"
    @onDelete="handleDeleteModule"
    @onMore="handleMore"
  >
    <module-title :mode="mode" :title="moduleData.title || '角色选择'" @onChange="handleTitleChange"></module-title>
    <div class="tab-container">
      <div class="tab-box">
        <editable-box :mode="mode" :includeBtns="['edit']" @onEdit="handleEditTabBar">
          <div>
            <div class="tab-bar" :class="{ 'has-tab-btn': moduleData.tabList.length > 7 }">
              <div class="tab-btn prev" :class="{ disabled: tabScrollNum == 7 }" @click="handleSlideTabBar('prev')">
                <i class="el-icon el-icon-caret-left"></i>
              </div>
              <div class="tab-wrapper">
                <div
                  class="tab"
                  :style="{
                    width: tabBarWidth + 'px',
                    transform: `translateX(-${tabScrollLeft}px)`
                  }"
                >
                  <div
                    class="tab-item"
                    v-for="(tab, tabIndex) in tabList"
                    :key="tab.key"
                    :class="{ active: activeTab === tabIndex }"
                    @click="handleTabChange(tabIndex)"
                  >
                    <div class="tab-icon" v-if="tab.icon">
                      <img :src="tab.icon" alt="icon" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-btn next"
                :class="{ disabled: tabScrollNum == moduleData.tabList.length }"
                @click="handleSlideTabBar('next')"
              >
                <i class="el-icon el-icon-caret-right"></i>
              </div>
            </div>
            <div class="tab-name">{{ currentTab.title }}</div>
          </div>
        </editable-box>

        <div class="attr-info" v-if="currentTab.isShowAttr">
          <template v-if="currentTab.attrList && currentTab.attrList.length > 0">
            <draggable
              class="attr-list"
              v-model="attrList"
              :animation="200"
              :group="'characterProfileAttrList'"
              :disabled="mode !== 'edit'"
              :ghostClass="'ghost'"
              :handle="'.edit-drag'"
              @start="dragAttr = true"
              @end="dragAttr = false"
              @change="handleSortAttr"
            >
              <div
                class="item-box"
                v-for="(attr, index) in attrList"
                :style="{
                  width: attr.isOneLine ? '100%' : 'calc(50% - 23px)'
                }"
                :key="attr.key"
              >
                <attr-box
                  :mode="mode"
                  :data="attr"
                  @onAdd="handleAddAttr(index)"
                  @onDelete="handleDeleteAttr(index)"
                  @onChange="data => handleAttrChange(index, data)"
                ></attr-box>
              </div>
            </draggable>
          </template>
          <template v-else-if="mode == 'edit'">
            <button class="add-btn" @click.stop="handleAddAttr">
              <i class="icon wiki-editable-add"></i>
            </button>
          </template>
        </div>

        <div class="skill-info" v-if="currentTab.isShowSkill">
          <template v-if="Object.keys(currentTab.skillData).length > 0">
            <skill-info
              :key="currentTab.skillData.key"
              :mode="mode"
              size="small"
              :data="currentTab.skillData"
              @onAdd="handleAddSkillInfo"
              @onDelete="handleDeleteSkillInfo"
              @onChange="data => hanldeSkillDataChange(data)"
            ></skill-info>
          </template>
          <template v-else-if="mode == 'edit'">
            <button class="add-btn" @click.stop="handleAddSkillInfo">
              <i class="icon wiki-editable-add"></i>
            </button>
          </template>
        </div>
        <!-- 编辑 -->
        <tabbar-edit-panel
          v-if="mode === 'edit'"
          ref="tabbarEditPanel"
          :mode="mode"
          :tabs="moduleData.tabList"
          @onDelete="handleDeleteTab"
          @onChange="handleTabListChange"
        ></tabbar-edit-panel>
      </div>
      <div class="container">
        <div class="top-desc" v-if="currentTab.isShowTopDesc">
          <text-box type="editor" :mode="mode" :value="currentTab.topDesc" @onChange="handleTabTopDescChange">
            {{ currentTab.name || "顶部描述" }}
          </text-box>
        </div>

        <template v-if="currentTab && currentTab.content && currentTab.content.length > 0">
          <div class="content" :key="activeTab" v-if="currentTab.type == 'image'">
            <editable-box :mode="mode" :includeBtns="['edit']" @onEdit="hanldeTabImageContentEdit">
              <div class="image-content">
                <img v-if="currentTab.content.length === 1" :src="currentTab.content[0]" alt="" class="preview-image" />
                <div v-else class="multi-image">
                  <swiper :auto-destroy="true" :auto-update="true" :options="swiperOptions" class="image-swiper-box">
                    <swiper-slide v-for="(item, index) in currentTab.content" :key="index" class="image-swiper-slide">
                      <img :src="item" alt="" class="swiper-lazy preview-image" />
                    </swiper-slide>
                  </swiper>
                  <div class="image-swiper-button prev"></div>
                  <div class="image-swiper-button next"></div>
                </div>
                <!-- 多图编辑 -->
                <image-edit-panel
                  v-if="mode === 'edit'"
                  ref="imageEditPanel"
                  :mode="mode"
                  :imgs="currentTab.content"
                  @onChange="handleImageContentChange"
                ></image-edit-panel>
              </div>
            </editable-box>
          </div>
          <div class="content" :key="activeTab" v-if="currentTab.type == 'video'">
            <div class="video-content" :class="{ 'is-edit': mode === 'edit' }">
              <div class="video">
                <div class="video-box" v-if="currentSelectVideo">
                  <div class="cover" v-if="!playVideo">
                    <img :src="currentSelectVideo.cover" alt="" />
                    <img
                      v-if="currentSelectVideo.cover"
                      class="play-icon"
                      src="@/assets/images/video-pause-icon.png"
                      alt=""
                      @click="handlePlayVideo(currentSelectVideo.src)"
                    />
                  </div>
                  <video v-else :src="playVideo" controls></video>
                  <div class="edit-btns" v-if="mode === 'edit'">
                    <button class="btn edit-btn">
                      <upload-video
                        type="edit"
                        :data="currentSelectVideo"
                        @onUploaded="(cover, src) => handleVideoContentEdit(currentSelectVideo.index, cover, src)"
                      >
                        <i class="icon wiki-editable-edit"></i>
                      </upload-video>
                    </button>
                    <button class="btn delete-btn" @click.stop="handleVideoContentDelete(currentSelectVideo.index)">
                      <i class="icon wiki-editable-delete"></i>
                    </button>
                    <button class="btn add-btn">
                      <upload-video
                        @onUploaded="(cover, src) => handleVideoUploaded(currentSelectVideo.index, cover, src)"
                      >
                        <i class="icon wiki-editable-add"></i>
                      </upload-video>
                    </button>
                  </div>
                </div>
              </div>
              <div class="video-multi" v-if="currentTab.content.length !== 1">
                <div class="video-list">
                  <div
                    class="video-item"
                    v-for="(video, index) in currentTab.content"
                    :key="video.key"
                    :class="{ seleted: currentSelectVideo.index == index }"
                    @click="handleSelectVideo(index, video)"
                  >
                    <img class="cover" :src="video.cover" alt="" />
                    <img class="play-icon" src="@/assets/images/video-pause-icon.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="upload-box" v-else-if="mode === 'edit'">
          <div class="upload-btn">
            <upload-image multiple @onImageUploaded="handleImageUploaded">
              <div class="upload-image-btn">
                <i class="icon iconfont icon-tianjia"></i>
                上传图片
              </div>
            </upload-image>
          </div>
          <div class="icon upload-btn">
            <upload-video @onUploaded="(cover, src) => handleVideoUploaded(0, cover, src)">
              <div class="upload-video-btn">
                <i class="iconfont icon-tianjia"></i>
                上传视频
              </div>
            </upload-video>
          </div>
        </div>

        <div class="bottom-desc" v-if="currentTab.isShowBottomDesc">
          <text-box type="editor" :mode="mode" :value="currentTab.bottomDesc" @onChange="handleTabBottomDescChange">
            {{ currentTab.name || "底部描述" }}
          </text-box>
        </div>
      </div>
    </div>
    <!-- 设置 -->
    <setup-panel v-if="mode === 'edit'" ref="setupPanel" :data="currentTab" @onChange="handleChangeData"></setup-panel>
  </module-box>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import draggable from "vuedraggable";
// components
import ModuleBox from "../../components/ModuleBox";
import UploadImage from "../../components/UploadImage";
import UploadVideo from "../../components/UploadVideo";
import TextBox from "../../components/TextBox";
import EditableBox from "../../components/EditableBox/index.jsx";
import ImageEditPanel from "./components/ImageEditPanel";
import TabbarEditPanel from "./components/TabbarEditPanel";
import SkillInfo from "./components/SkillInfo";
import SetupPanel from "./SetupPanel";
import ModuleTitle from "../../components/ModuleTitle";
import AttrBox from "./components/Attrbox";

export default {
  name: "TabInfo",
  components: {
    Swiper,
    SwiperSlide,
    draggable,
    ModuleBox,
    UploadImage,
    UploadVideo,
    TextBox,
    EditableBox,
    ImageEditPanel,
    TabbarEditPanel,
    SkillInfo,
    SetupPanel,
    ModuleTitle,
    AttrBox
  },
  props: {
    mode: String,
    moduleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeTab: 0,
      swiperOptions: {
        initialSlide: 0,
        zoom: {
          maxRatio: 2
        },
        navigation: {
          prevEl: ".image-swiper-button.prev",
          nextEl: ".image-swiper-button.next"
        }
      },
      playVideo: "",
      currentSelectVideo: "",
      dragTab: false,
      tabList: this.moduleData.tabList || [],
      tabScrollNum: 7,
      tabScrollLeft: 0,
      attrList: [],
      dragAttr: false
    };
  },
  computed: {
    currentTab() {
      return this.moduleData.tabList[this.activeTab];
    },
    tabBarWidth() {
      return this.moduleData.tabList.length * (80 + 12);
    }
  },
  watch: {
    moduleData(val) {
      this.tabList = val.tabList;
    },
    currentTab: {
      handler(val) {
        const currentTab = val;
        this.attrList = val.attrList;
        if (currentTab.type == "video") {
          this.currentSelectVideo = { index: 0, ...currentTab.content[0] };
        }
      },
      immediate: true
    }
  },

  mounted() {
    const query = this.$route.query;
    // 锚点定位
    if (query.active_tab) {
      let activeTab = Number(query.active_tab);
      activeTab = isNaN(activeTab) ? 0 : activeTab - 1;
      activeTab =
        activeTab <= 0
          ? 0
          : activeTab >= this.moduleData.tabList.length
          ? this.moduleData.tabList.length - 1
          : activeTab;
      const num = parseInt(activeTab / 6);
      for (let i = 0; i < num; i++) {
        this.handleSlideTabBar("next");
      }
      this.activeTab = activeTab;
    }
  },

  methods: {
    // 模块更多操作
    handleMore(command, data) {
      if (command === "copy") {
        const moduleData = JSON.parse(JSON.stringify(this.moduleData));
        this.$emit("onCopy", moduleData);
      }
    },
    // 模块设置
    handleOpenModuleSetupPanel() {
      this.$refs.setupPanel.open();
    },
    handleChangeData(currentTab) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.tabList.splice(this.activeTab, 1, currentTab);
      this.$emit("onChange", moduleData);
    },
    // 模块删除
    handleDeleteModule() {
      this.$emit("onDelete");
    },
    handleTitleChange(title) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.title = title;
      this.$emit("onChange", moduleData);
    },
    // tab切换
    handleTabChange(index) {
      this.activeTab = index;
      this.playVideo = "";
      this.currentSelectVideo = "";
    },
    // tab排序
    handleSortTab() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.tabList = this.tabList;
      this.$emit("onChange", moduleData);
    },
    handleDeleteTab(index) {
      this.activeTab = index - 1 <= 0 ? 0 : index - 1;
    },
    handleSlideTabBar(type) {
      const num = this.moduleData.tabList.length;
      if (type == "prev") {
        this.tabScrollNum -= 7;
        this.tabScrollLeft = this.tabScrollNum * (80 + 12);
        if (this.tabScrollNum <= 7) {
          this.tabScrollNum = 7;
          this.tabScrollLeft = 0;
        }
      } else {
        this.tabScrollNum += 7;
        this.tabScrollLeft = this.tabScrollNum * (80 + 12);
        if (this.tabScrollNum >= num) {
          this.tabScrollNum = num;
          this.tabScrollLeft = (num - 7) * (80 + 12);
        }
      }
    },
    handleEditTabBar() {
      this.$refs.tabbarEditPanel.open();
    },
    handleTabListChange(tabList) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.tabList = tabList;
      this.$emit("onChange", moduleData);
    },
    handleTabTopDescChange(desc) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.topDesc = desc;
      this.$emit("onChange", moduleData);
    },
    handleTabBottomDescChange(desc) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.bottomDesc = desc;
      this.$emit("onChange", moduleData);
    },
    handleChangeTab(index, title) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[index];
      currentTab.title = title;
      this.$emit("onChange", moduleData);
    },
    handleImageUploaded(imgList) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.type = "image";
      currentTab.content = currentTab.content.concat(imgList);
      this.$emit("onChange", moduleData);
    },

    hanldeTabImageContentEdit() {
      this.$refs.imageEditPanel.open();
    },
    handleImageContentChange(content) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.content = content;
      this.$emit("onChange", moduleData);
    },
    handlePlayVideo(src) {
      this.playVideo = src;
    },
    handleVideoUploaded(index, cover, src) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.type = "video";
      currentTab.content.splice(index + 1, 0, {
        key: Math.random().toString(16),
        cover,
        src
      });
      this.$emit("onChange", moduleData);
      // 将选中当前
      this.handleSelectVideo(index, currentTab.content[index]);
    },
    handleVideoContentEdit(index, cover, src) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.type = "video";
      currentTab.content.splice(index, 1, {
        key: Math.random().toString(16),
        cover,
        src
      });
      this.$emit("onChange", moduleData);
      // 将选中当前
      this.handleSelectVideo(index, currentTab.content[index]);
    },
    handleVideoContentDelete(index) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.type = "video";
      currentTab.content.splice(index, 1);
      this.$emit("onChange", moduleData);
      // 将选中前一个video
      let selectedIndex = index - 1;
      if (selectedIndex <= 0) {
        selectedIndex = 0;
      }
      this.handleSelectVideo(selectedIndex, currentTab.content[selectedIndex]);
    },
    handleSelectVideo(index, video) {
      this.playVideo = "";
      this.currentSelectVideo = {
        index,
        ...video
      };
    },
    handleAddSkillInfo() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.skillData = {
        isShowIcon: true,
        isShowName: true,
        isShowDesc: true,
        isShowMore: true,
        icon: "",
        name: "",
        label: "",
        desc: "",
        moreInfo: ""
      };
      this.$emit("onChange", moduleData);
    },
    handleDeleteSkillInfo() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.skillData = {};
      this.$emit("onChange", moduleData);
    },
    hanldeSkillDataChange(data) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.skillData = data;
      this.$emit("onChange", moduleData);
    },
    // 属性排序
    handleSortAttr() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.attrList = this.attrList;
      this.$emit("onChange", moduleData);
    },
    // 属性编辑
    handleAttrChange(dataIndex, data) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.attrList.splice(dataIndex, 1, data);
      this.$emit("onChange", moduleData);
    },
    // 属性添加
    handleAddAttr(dataIndex = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      if (!currentTab.attrList) currentTab.attrList = [];
      currentTab.attrList.splice(dataIndex + 1, 0, {
        key: Math.random().toString(16),
        title: "",
        content: ""
      });
      this.$emit("onChange", moduleData);
    },
    // 属性删除
    handleDeleteAttr(dataIndex = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentTab = moduleData.tabList[this.activeTab];
      currentTab.attrList.splice(dataIndex, 1);
      this.$emit("onChange", moduleData);
    }
  }
};
</script>

<style lang="less" scoped>
.tab-container {
  width: 100%;
  padding: 17px 20px;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(207, 207, 207, 0.29);
  border-radius: 8px;
  .tab-box {
    background: #f5f7f8;
    border-radius: 4px;
    margin-bottom: 8px;

    .tab-bar {
      position: relative;
      width: 100%;
      padding: 24px 24px 0;
      &.has-tab-btn {
        padding: 24px 49px 0;
        .tab-btn {
          display: block;
        }
      }
      .tab-btn {
        display: none;
        position: absolute;
        z-index: 10;
        width: 16px;
        height: 80px;
        background: #232323;
        cursor: pointer;
        line-height: 80px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        border-radius: 2px;
        i {
          transform: scale(0.8);
        }
        &.disabled {
          background: #b0b3bb;
          color: #999999;
          cursor: not-allowed;
        }
        &.prev {
          left: 24px;
          top: 24px;
        }
        &.next {
          right: 24px;
          top: 24px;
        }
      }
    }

    .tab-wrapper {
      width: 100%;
      overflow: hidden;
    }
    .tab {
      width: 100%;
      height: 80px;
      display: flex;
      transition: all 0.5s;
      .tab-item {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        font-size: 15px;
        font-weight: 400;
        margin-right: 12px;
        transition: all 0.3s;
        background-color: #e9ebec;
        &:hover {
          cursor: pointer;
        }
        .tab-icon {
          flex-shrink: 0;
          width: 80px;
          height: 80px;
          opacity: 0.5;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .active {
        .tab-icon {
          opacity: 1;
          border: 2px solid #000;
          img {
            border: 1px solid #ffffff;
          }
        }
      }
    }
    .tab-name {
      padding: 22px 24px 19px 24px;
      font-size: 20px;
      font-weight: bold;
      color: #212121;
      line-height: 30px;
    }
    .skill-info {
      padding: 24px 24px 8px;
      border-top: 1px solid #e9ebec;
    }
    .attr-info {
      padding: 4px 12px 12px;
      .attr-list {
        display: flex;
        flex-wrap: wrap;
        gap: 0 46px;
        .item-box {
          margin-bottom: 8px;
          width: calc(50% - 23px);
        }
      }
    }
  }

  .container {
    width: 100%;
    // min-height: 100px;
    background: #fff;
    .top-desc {
      margin-bottom: 12px;
    }
    .bottom-desc {
      margin-top: 20px;
    }

    .image-content {
      width: 100%;
      height: 414px;
      img {
        width: 100%;
        height: 100%;
        max-height: 414px;
        object-fit: contain;
        border: 1px solid #e1e1e1;
      }
      .multi-image {
        width: 100%;
        height: 414px;
        position: relative;
      }
      .image-swiper-box {
        width: 100%;
        height: 100%;
        .image-swiper-slide {
          // background-image: url("../../../../../assets/images/charactor-img-bg.png");
          // background-size: 100%;
          // background-repeat: no-repeat;
          // padding: 3px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .image-swiper-button {
        width: 32px;
        height: 140px;
        background: rgba(0, 0, 0, 0.6);
        border: 1px solid #898989;
        line-height: 140px;
        text-align: center;
        cursor: pointer;
        &.prev {
          position: absolute;
          top: 50%;
          left: 46px;
          z-index: 100;
          transform: translate(-50%, -50%);
          &::before {
            content: "";
            display: inline-block;
            border-right: 6px solid #fff;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-radius: 2px;
          }
        }
        &.next {
          position: absolute;
          top: 50%;
          right: 14px;
          z-index: 100;
          transform: translate(-50%, -50%);
          &::before {
            content: "";
            display: inline-block;
            border-left: 6px solid #fff;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-radius: 2px;
          }
        }
      }
    }
    .video-content {
      width: 100%;
      height: auto;
      display: flex;
      &.is-edit {
        .video:hover {
          .edit-btns {
            display: inline-flex;
          }
        }
      }
      & > .video {
        width: 100%;
        height: auto;
        position: relative;

        img {
          width: 100%;
        }
        video {
          width: 100%;
        }
      }
      .cover {
        width: 100%;
        position: relative;
        .play-icon {
          cursor: pointer;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 97px;
          height: 97px;
        }
      }
      .video-multi {
        width: 158px;
        height: auto;
        .video-list {
          width: 158px;
          height: 330px;
          overflow: auto;
          margin-left: 13px;

          .video-item {
            width: 100%;
            height: 89px;
            margin-bottom: 20px;
            cursor: pointer;
            border-radius: 4px;
            position: relative;
            .cover {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 4px;
            }
            .play-icon {
              width: 22px;
              height: 22px;
              position: absolute;
              right: 6px;
              bottom: 4px;
            }
          }
          .seleted {
            border: 1px solid #000000;
          }
        }
      }
    }

    .upload-box {
      display: flex;
      gap: 20px;
      justify-content: center;
      margin: 50px 0;
    }
    .upload-btn {
      width: 120px;
      height: 40px;
      border: 1px dotted #666;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #666;
      cursor: pointer;
      .icon {
        margin-right: 12px;
      }
    }
    .upload-image-btn {
      width: 100%;
      height: 100%;
      line-height: 40px;
      background: #c7c9db;
    }
    .upload-video-btn {
      width: 100%;
      height: 100%;
      line-height: 40px;
      background: #c7c9db;
    }
  }
}
.add-btn {
  width: 20px;
  height: 20px;
  color: #ffffff;
  border-radius: 4px;
  margin-left: 3px;
  border: none;
  vertical-align: middle;
  line-height: 20px;
  text-align: center;
  &:hover {
    opacity: 0.9;
  }
  .icon {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}

.edit-btns {
  display: none;
  position: absolute;
  height: 20px;
  right: 0;
  top: 0px;
  .btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 3px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    &:hover {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
